export class UploadFileInformation {
  applicationType: string;
  applicationID: number;
  damsApplicationID: string;
  applicationLocation: string;
  files: string[];

  setData(applicationType: string, damsApplicationID: string, applicationLocation: string,
          files: string[] ): void {
    this.applicationType = applicationType;
    this.damsApplicationID = damsApplicationID;
    this.applicationLocation = applicationLocation;
    this.files = files;
  }

 
}



// WEBPACK FOOTER //
// ./src/app/shared/data-objects/upload-file-information.ts